import { Alert } from '@mui/material';
import { useEffect, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router';
import { Loader } from '../../../components/Loader/Loader';
import { ROUTES } from '../../../constants/RouteNameMapping';
import { KpiCollectionConfigs } from './KpiCollectionConfigs';
import { useKpiCollectionSettingsState } from './state/kpi-collection-state';

export const NewKpiCollectionConfigId = 'new' as const;

export function KpiCollectionConfigsRedirect() {
  const navigate = useNavigate();
  const { data: configurations, isLoading } = useKpiCollectionSettingsState();

  useEffect(() => {
    if (!isLoading && configurations !== undefined) {
      const targetId = configurations.length > 0 ? configurations[0].id : NewKpiCollectionConfigId;
      navigate(`/${ROUTES.KPI}/${ROUTES.KPI_DATA_COLLECTION_CONFIGURATION}/${targetId}`, {
        replace: true,
      });
    }
  }, [configurations, isLoading, navigate]);

  return null;
}

export function KpiCollectionConfigsPage() {
  const { configId } = useParams<{ configId: string }>();
  const { data: configurations, isLoading, isError } = useKpiCollectionSettingsState();

  const initialConfiguration = useMemo(() => {
    if (configId === NewKpiCollectionConfigId || !configurations) {
      return undefined;
    }
    return configurations.find((config) => String(config.id) === configId);
  }, [configId, configurations]);

  if (isError) {
    return (
      <Alert severity='error' sx={{ width: '100%', height: 'min-content' }}>
        Failed to load KPI collection configurations
      </Alert>
    );
  }
  if (isLoading) {
    return <Loader />;
  }

  return <KpiCollectionConfigs key={configId} initialConfiguration={initialConfiguration} />;
}
